import { Color, Flex, Text } from '@billy/design-system'
import { useTranslation } from 'react-i18next'

import { formatDate } from '../../../../../../../../src/utils'

interface YTDTooltipProps {
  startDate: string
  endDate: string
}

const DATE_FORMAT = 'dd/MM/yyyy'

export const YTDTooltip = ({ startDate, endDate }: YTDTooltipProps) => {
  const { t } = useTranslation()

  return (
    <Flex flexDirection="column">
      <Text color={Color.White}>{t('reports.ytd')}</Text>
      <Text color={Color.White}>
        {formatDate(startDate, DATE_FORMAT)} - {formatDate(endDate, DATE_FORMAT)}
      </Text>
    </Flex>
  )
}
